import { ClientInferRequest } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type AddPricedProcessStepPayload = ClientInferRequest<
  typeof contract.quoteRequestLines.addPricedProcessStep
>["body"];

export const fetchAddPricedProcessStep = async (
  payload: AddPricedProcessStepPayload & { quoteRequestLineId: string },
) => {
  const response = await api.quoteRequestLines.addPricedProcessStep.mutation({
    params: { id: payload.quoteRequestLineId },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to add priced process step", response.status, response.body);
};
